import script from "./communityWritePage.vue?vue&type=script&setup=true&lang=js"
export * from "./communityWritePage.vue?vue&type=script&setup=true&lang=js"

import "./communityWritePage.vue?vue&type=style&index=0&id=5a1cf706&lang=css"

const __exports__ = script;

export default __exports__